<template>
  <div class="md_header">
    <div class="container pt-2" style="height: 60px;">
      <div class="align-horizontal h_center mt-2" style="position: relative;" >
        <div class="left">
          <b-link @click="_back" v-show="!hide_back">
            <b-img :src="require('../../assets/image/ic_back.png')" class="back_btn" />
          </b-link>
        </div>
        <div class="title_wrapper">
          <label class="title">{{title.primary}}</label>
        </div>
        <div class="right">
          <div class="align-horizontal">
            <a variant="white" class="mr-1" @click="() => {self.$emit('onLike')}" v-if="!hide_like">
              <b-img class="like_btn" :src="is_like ? require('../../assets/image/ic_heart_on@2x.png') : require('../../assets/image/ic_heart_off@2x.png')" />
            </a>
            <a variant="white" class="" @click="() => {self.$emit('onShare')}" v-if="!hide_share">
              <b-img class="share_btn" :src="require('../../assets/image/ic_share@2x.png')" />
            </a>
            <b-link @click="_close" v-show="!hide_close">
              <b-icon
                style="color: black"
                scale="2.5"
                icon="x"></b-icon>
            </b-link>
          </div>
        </div>
      </div>
      <div class="full align-vertical center" v-if="!title.isSingle">
        <div class="align-horizontal">
          <b-img :src="require('../../assets/image/ic_address_detail@2x.png')" style="height: 1.3em;" />
          <span class="address_text">{{title.address}}</span>
        </div>
        <span class="title">{{title.secondary}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MdHeaderBar2",
    props:{
      title: {
        type: Object,
        default: ()=>{
          return {
            primary: '',
            isSingle: true,
            secondary: '',
            address: '',
          }
        }
      },
      hide_back: {
        type: Boolean,
        default: false
      },
      hide_close: {
        type: Boolean,
        default: true,
      },
      hide_like: {
        type: Boolean,
        default: true,
      },
      is_like: {
        type: Boolean,
        default: false,
      },
      hide_share: {
        type: Boolean,
        default: true,
      },
      isCustomBack: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
          self: this,
        }
    },
    methods: {
        _back() {
          if (this.isCustomBack)
            this.$emit('back');
          else
            this.$router.back();
        },
        _close() {
            this.$router.back();
        }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/vars";
  .container {
    background-color: white;
  }
  .md_header {
    //height: $md_header_height;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 99;
    width: 480px;
    margin: auto;
    height: 60px;
  }
  .back_btn { display: flex; width: 15px; align-items: center; justify-content: center; margin-right: 34px;height: 25px; }
  .left {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .right {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .address_text {
    color: #0660e2;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
    margin-left: 6px;
  }
  .title {
    color: black;
    font-size: $fs_18;
    font-family: $korean_gd_15_r;
    margin: auto;
    height: 40px;
  }
  .like_btn { width: 35px; align-items: center; justify-content: center; margin-right: 15px; }
  .share_btn { width: 35px; align-items: center; justify-content: center; margin-right: 15px; }
</style>



// WEBPACK FOOTER //
// src/components/controls/MdHeaderBar2.vue